import { vec3 } from "gl-matrix";

export function containsNans(vec: vec3) {
  return isNaN(vec[0]) || isNaN(vec[1]) || isNaN(vec[2]);
}

export function clamp01(value: number) {
  return Math.max(0, Math.min(1, value));
}
